import React, { useState, useEffect } from 'react'
import NumericInput from 'react-numeric-input'
import { Form } from 'react-bootstrap'
import classNames from 'classnames/bind'
import AsyncSelect from 'react-select/async'
import CreatableSelect from 'components/Select/CreatableSelect'
import { Autocomplete } from '@material-ui/lab'
import { styled, createTheme } from '@mui/material/styles'
import { TextField } from '@material-ui/core'

import Select from 'components/Select'
import AutoCompletePopper from 'components/Popper/AutoCompletePopper'

import './style.scss'

const CustomTextField = styled(TextField)({
  '& .MuiAutocomplete-inputRoot': {
    padding: '4px !important',
    fontSize: '14px',
  },
  '& .MuiOutlinedInput-root': {
    padding: '7px 10px',
  },
  '& .MuiOutlinedInput-marginDense': {
    padding: '4px',
  },
})

const SuggestionInput = ({
  value,
  suggestions = [],
  inputWidth,
  onChange,
  onBlur,
}) => {
  const [inputValue, setInputValue] = useState('')
  const typedValueRef = React.useRef(null)
  const committedRef = React.useRef(false)
  const options = React.useMemo(
    () =>
      suggestions.map((number) => ({ value: number, label: String(number) })),
    [suggestions],
  )
  const selectedValue =
    value === '' || value == null
      ? null
      : { value: Number(value), label: String(value) }

  const finishEdit = (nextValue) => {
    if (committedRef.current) return
    committedRef.current = true

    if (nextValue !== null && nextValue !== undefined) {
      const number = Number(nextValue)
      if (Number.isFinite(number) && number >= 0) onChange?.(number)
    }
    onBlur?.()
  }

  return (
    <CreatableSelect
      autoFocus
      defaultMenuIsOpen
      openMenuOnFocus
      classNamePrefix="cell-edit-suggestion"
      aria-label="ส่วนลด %"
      placeholder=""
      value={selectedValue}
      inputValue={inputValue}
      options={options}
      isClearable={false}
      tabSelectsValue={false}
      createOptionPosition="first"
      formatCreateLabel={(input) => input}
      isValidNewOption={(input, selected, currentOptions) =>
        input.trim() !== '' &&
        Number.isFinite(Number(input)) &&
        Number(input) >= 0 &&
        !currentOptions.some((option) => String(option.value) === input.trim())
      }
      noOptionsMessage={() => 'กรอกตัวเลขตั้งแต่ 0 ขึ้นไป'}
      onInputChange={(input, { action }) => {
        if (action === 'input-change') {
          typedValueRef.current = input
          setInputValue(input)
        }
      }}
      onChange={(option) => finishEdit(option?.value)}
      onBlur={() => finishEdit(typedValueRef.current)}
      onKeyDown={(event) => {
        if (event.key === 'Escape') {
          event.preventDefault()
          finishEdit(null)
        }
      }}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      menuPlacement="auto"
      maxMenuHeight={180}
      styles={{
        container: (base) => ({ ...base, width: inputWidth }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
      }}
    />
  )
}

const CellEditInput = (props) => {
  const selectRef = React.useRef()
  const numericInputWidth = props?.inputWidth || 90

  useEffect(() => {
    function handleClickOutside(event) {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        props?.onBlur?.()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [props])
  return (
    <div key={`${props.field}-${props?.tabKey}`}>
      {props?.isEdit ? (
        <div>
          {props.type === 'text' ? (
            <Form.Control
              autoFocus
              className={classNames('form-control', props.className)}
              value={props?.value}
              onChange={(e) => {
                props?.onChange(e)
              }}
              style={{ width: '200px' }}
              {...props}
            />
          ) : props?.type === 'select' ? (
            <div ref={selectRef}>
              <Select
                className="basic-single"
                classNamePrefix="select"
                placeholder={props?.placeholder}
                name={props?.name}
                value={props?.value}
                options={props?.option || []}
                getOptionLabel={props?.getOptionLabel}
                getOptionValue={props?.getOptionValue}
                onChange={(value) => {
                  props?.onChange(value)
                }}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  control: (base) => ({
                    ...base,
                    width: 200,
                  }),
                  ...props?.styles,
                }}
                {...props}
              />
            </div>
          ) : props?.type === 'async-select' ? (
            <div ref={selectRef}>
              <AsyncSelect
                loadOptions={props?.loadOptions}
                defaultOptions
                closeMenuOnSelect={true}
                className="basic-single"
                classNamePrefix="select"
                placeholder={props?.placeholder}
                name={props?.name}
                value={props?.value}
                getOptionLabel={props?.getOptionLabel}
                getOptionValue={props?.getOptionValue}
                onChange={(value) => {
                  props?.onChange(value)
                }}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  control: (base) => ({
                    ...base,
                    width: 200,
                  }),
                  ...props?.styles,
                }}
                {...props}
              />
            </div>
          ) : props?.type === 'autocomplete' ? (
            <div>
              <Autocomplete
                openOnFocus
                freeSolo
                disableClearable
                options={props?.options || []}
                getOptionLabel={(option) => option.label}
                filterOptions={(options) => options.slice(0, 20)}
                value={props?.value}
                onChange={(e, value) => props?.onSelected(value)}
                onInputChange={(event, newInputValue) => {}}
                renderInput={(params) => (
                  <CustomTextField
                    {...params}
                    // inputRef={inputRef}
                    disabled
                    variant="outlined"
                    size="small"
                    autoFocus
                    onChange={props?.handleChangeInput}
                  />
                )}
                PopperComponent={AutoCompletePopper}
                {...props}
              />
            </div>
          ) : props?.type === 'suggestion' ? (
            <SuggestionInput
              value={props?.value}
              suggestions={props?.suggestions}
              inputWidth={numericInputWidth}
              onChange={props?.onChange}
              onBlur={props?.onBlur}
            />
          ) : (
            <div style={{ width: numericInputWidth }}>
              <NumericInput
                autoFocus
                snap
                mobile={true}
                className="form-control text-right"
                style={false}
                value={props?.value}
                onChange={(value) => {
                  props?.onChange(value)
                }}
                {...props}
              />
            </div>
          )}
        </div>
      ) : (
        <span
          onClick={props?.onClick}
          className={'dotted-line ' + (props?.value < 0 ? 'text-danger' : '')}
        >
          {props?.cellValue}
        </span>
      )}
    </div>
  )
}

export default CellEditInput
